exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper-app{display:flex;height:100vh;width:100vw;flex-direction:column;overflow:hidden}.wrapper-app__row{display:flex;width:100%;height:100%;overflow:hidden}.wrapper-app__header{width:100%}.wrapper-app__sidebar-menu{height:100%}.wrapper-app__content{width:100%;padding:8px 20px;overflow:auto}@media screen and (max-width:768px){.wrapper-app__content{padding:10px}}.wrapper-app__content::-webkit-scrollbar,.wrapper-app__content::-webkit-scrollbar-thumb{height:6px!important;width:6px!important;border-radius:4px!important}", ""]);

// exports
